import React from 'react';
import cn from 'classnames';
import type { IconProps } from '../icon-prop-types';
import { IconSizes } from '../icon-prop-types';
import * as Styles from '../Icon.module.scss';

export const ImportIcon = ({ fill = 'black', size = 'xsmall' }: IconProps) => {
    const fillStyles = cn(Styles[fill], Styles.fill);
    const iconSize = IconSizes[size];

    return (
        <svg width={iconSize} height={iconSize} viewBox="0 0 34 33" xmlns="http://www.w3.org/2000/svg">
            <g fillRule="nonzero" className={fillStyles}>
                <path d="M28.792 0H11.208c-1.38 0-2.706.458-3.682 1.272C6.549 2.086 6 3.19 6 4.342v3.04c0 .48.466.868 1.042.868.575 0 1.041-.389 1.041-.868v-3.04c0-.69.33-1.353.916-1.842.586-.489 1.38-.763 2.21-.763h17.583c.829 0 1.623.274 2.21.763.586.489.915 1.151.915 1.842v24.316c0 .69-.33 1.353-.915 1.842-.587.489-1.381.763-2.21.763H11.208c-.828 0-1.623-.274-2.21-.763-.585-.489-.915-1.151-.915-1.842v-3.04c0-.48-.466-.868-1.041-.868-.576 0-1.042.389-1.042.868v3.04c0 1.151.549 2.256 1.526 3.07.976.814 2.301 1.272 3.682 1.272h17.584c1.38 0 2.706-.458 3.682-1.272.977-.814 1.526-1.919 1.526-3.07V4.342c0-1.151-.549-2.256-1.526-3.07C31.498.458 30.173 0 28.792 0z" />
                <path d="M1.03 17.996H22.46l-6.633 6.301a.97.97 0 0 0-.01 1.407c.4.391 1.051.395 1.457.01l8.418-8.006A.977.977 0 0 0 26 17a.976.976 0 0 0-.307-.708l-8.403-8a1.062 1.062 0 0 0-1.464.002.976.976 0 0 0 .002 1.414l6.633 6.3H1.03c-.568 0-1.029.446-1.029.995 0 .549.46.993 1.03.993z" />
            </g>
        </svg>
    );
};
